import apiClient from "../common/apiClient";

export default class UserController {

  async Create(data, token) {
    try {
      return await apiClient.post("/menuaccess", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async GetRoles(tenantId, token) {
    try {
      return await apiClient.get("/rolemaster/" + tenantId, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async GetRoleMapped(tenantId, token) {
    try {
      return await apiClient.get("/menuaccess/" + tenantId, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

}
